module.exports = __webpack_public_path__ + "static/media/staff.dd199201.jpg";